import types from './types'

// Sites
const clearSites = () => ({ type: types.CLEAR_SITES })
const fetchingSites = () => ({ type: types.FETCHING_SITES })
const fetchingSitesSuccess = sites => ({
  type: types.FETCHING_SITES_SUCCESS,
  sites,
})
const fetchingSitesError = error => ({
  type: types.FETCHING_SITES_ERROR,
  error,
})
const mergingSite = () => ({
  type: types.MERGING_SITE,
})
const mergingSiteSuccess = mergeSiteResults => ({
  type: types.MERGING_SITE_SUCCESS,
  mergeSiteResults,
})
const mergingSiteError = mergeSiteError => ({
  type: types.MERGING_SITE_ERROR,
  mergeSiteError,
})
const setSiteSearchCriteria = criteria => ({
  type: types.SET_SITE_SEARCH_CRITERIA,
  criteria,
})

const updatingSite = () => ({ type: types.UPDATING_SITE })
const updatingSiteSuccess = site => ({
  type: types.UPDATING_SITE_SUCCESS,
  site,
})
const updatingSiteError = error => ({
  type: types.UPDATING_SITE_ERROR,
  error,
})

// Site Users
const creatingSiteUser = () => ({ type: types.CREATING_SITE_USER })
const creatingSiteUserSuccess = siteUser => ({
  type: types.CREATING_SITE_USER_SUCCESS,
  siteUser,
})
const creatingSiteUserError = error => ({
  type: types.CREATING_SITE_USER_ERROR,
  error,
})

const creatingSiteUsers = () => ({ type: types.CREATING_SITE_USERS })
const creatingSiteUsersSuccess = (
  siteId,
  newSiteUsers,
  failedSiteUsers,
  invalidSiteUsers,
  sendEmail,
) => ({
  type: types.CREATING_SITE_USERS_SUCCESS,
  siteId,
  newSiteUsers,
  failedSiteUsers,
  invalidSiteUsers,
  sendEmail,
})
const creatingSiteUsersError = error => ({
  type: types.CREATING_SITE_USERS_ERROR,
  error,
})

const fetchingSiteUsers = () => ({ type: types.FETCHING_SITE_USERS })
const fetchingSiteUsersSuccess = (siteId, siteUsers) => ({
  type: types.FETCHING_SITE_USERS_SUCCESS,
  siteId,
  siteUsers,
})
const fetchingSiteUsersError = error => ({
  type: types.FETCHING_SITE_USERS_ERROR,
  error,
})

const updatingSiteUser = () => ({ type: types.UPDATING_SITE_USER })
const updatingSiteUserSuccess = siteUser => ({
  type: types.UPDATING_SITE_USER_SUCCESS,
  siteUser,
})
const updatingSiteUserError = error => ({
  type: types.UPDATING_SITE_USER_ERROR,
  error,
})

const remindingSiteUser = () => ({ type: types.REMINDING_SITE_USER })
const remindingSiteUserSuccess = () => ({
  type: types.REMINDING_SITE_USER_SUCCESS,
})
const remindingSiteUserError = error => ({
  type: types.REMINDING_SITE_USER_ERROR,
  error,
})

const remindingSiteUsers = () => ({ type: types.REMINDING_SITE_USERS })
const remindingSiteUsersSuccess = () => ({
  type: types.REMINDING_SITE_USERS_SUCCESS,
})
const remindingSiteUsersError = error => ({
  type: types.REMINDING_SITE_USERS_ERROR,
  error,
})

const resetBulkAddUsers = () => ({ type: types.RESET_BULK_ADD_USERS })

export default {
  // Sites
  clearSites,
  fetchingSites,
  fetchingSitesSuccess,
  fetchingSitesError,
  mergingSite,
  mergingSiteSuccess,
  mergingSiteError,
  setSiteSearchCriteria,
  updatingSite,
  updatingSiteSuccess,
  updatingSiteError,
  // Site Users
  creatingSiteUser,
  creatingSiteUserSuccess,
  creatingSiteUserError,
  creatingSiteUsers,
  creatingSiteUsersSuccess,
  creatingSiteUsersError,
  fetchingSiteUsers,
  fetchingSiteUsersSuccess,
  fetchingSiteUsersError,
  updatingSiteUser,
  updatingSiteUserSuccess,
  updatingSiteUserError,
  remindingSiteUser,
  remindingSiteUserSuccess,
  remindingSiteUserError,
  remindingSiteUsers,
  remindingSiteUsersSuccess,
  remindingSiteUsersError,
  resetBulkAddUsers,
}



// WEBPACK FOOTER //
// ./src/redux/sitesManager/actions.js